import service from '@/store/services/pessoajuridicatipos-service';

const state = {
  list: {},
  pessoajuridicatipo: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, pessoajuridicatipo) => {
    state.pessoajuridicatipo = pessoajuridicatipo;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((pessoajuridicatipo) => { commit('SET_RESOURCE', pessoajuridicatipo); });
  },

  baixarArquivo({ commit, dispatch }, params) {
    // Chama a função do serviço para baixar o PDF
      return service.downloadPDF(params[0],params[1])
        .then((resposta) => {
          // Manipular a resposta, se necessário
          //console.log("PDF baixado com sucesso!", resposta);
          return resposta;
        })
        .catch((erro) => {
          // Lidar com erros, como usuário não autenticado
          console.error("Erro ao baixar a apólice:", erro);
          throw erro;
        });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((pessoajuridicatipo) => { commit('SET_RESOURCE', pessoajuridicatipo); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((pessoajuridicatipo) => { commit('SET_RESOURCE', pessoajuridicatipo); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  pessoajuridicatipo: state => state.pessoajuridicatipo,
  dropdown: (state) => {
    return state.list.map(pessoajuridicatipo => ({
      id: pessoajuridicatipo.id,
      name: pessoajuridicatipo.name,
      tipopessoa_id: pessoajuridicatipo.tipopessoa?.id
    }));
  }
};

const pessoajuridicatipos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default pessoajuridicatipos;
